import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import InputField from "../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../utils/api";
import {
  validateNumber,
  validateNumberInput,
} from "../../../utils/validateFields";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const GeneralDisclosure25 = ({ hide }) => {
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);

  const questionData = [
    {
      fieldName: "assuranceStatement",
      title:
        "i. Provide a link or reference to the external assurance report(s) or assurance statement(s).",
      letter: "i.",
    },
    {
      fieldName: "assuranceProvider",
      title:
        "ii. Describe the scope of information and processes covered, the responsibilities of the organization in relation to the assurance provider, the assurance standards used, the level of assurance obtained, any limitations of the assurance process, and a summary of the conclusions reached by the assurance provider.",
      letter: "ii.",
    },
    {
      fieldName: "qualificationAndExpertise",
      title:
        "iii. Describe the relationship between the organization and the assurance provider, including details on the independence of the assurance provider, their experience, qualifications, and expertise.",
      letter: "iii.",
    },
  ];
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GeneralDisclosures2021`);
      const res1 = res?.data?.data?.GeneralDisclosures2021?.extenalAssurance;
      setData(res1);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      console.log(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      policyAndProcedure: data?.policyAndProcedure || "", // Default empty string for policy and procedure
      // b
      underGoneAssurance: data?.underGoneAssurance || {
        assuranceStatement: "", // Default empty string for assurance statement
        assuranceProvider: "", // Default empty string for assurance provider
        qualificationAndExpertise: "", // Default empty string for qualification and expertise
      },
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "distance" && !validateNumberInput(value)) return;
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    if (name === "policyAndProcedure")
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    else
      setFormData((prev) => ({
        ...prev,
        underGoneAssurance: { ...prev.underGoneAssurance, [name]: value },
      }));
  };

  const validateForm = () => {
    const newErrors = {};
    questionData.forEach((el) => {
      if (
        !formData["underGoneAssurance"][el.fieldName] ||
        formData["underGoneAssurance"][el.fieldName].trim() === ""
      ) {
        newErrors[el.fieldName] = `This field is Required`;
      }
    });

    if (formData?.policyAndProcedure === "") {
      newErrors["policyAndProcedure"] = `This field is Required`;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) return;

      let transformedData2 = {
        extenalAssurance: formData,
        submitted2_5: true,
        type: "GeneralDisclosures2021",
      };
      console.log("abc", transformedData2);

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/general-disclosure/2-6/${id}`);
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-6/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <p className={styles.main_heading}>2-5 External assurance</p>
      {/* a */}
      <Box sx={{ mt: hide? "-1rem" : "2.5rem" }}>
        <p
          className={styles.ques_heading}
          style={{ textIndent: "-1rem",  }}
        >
          a. Describe the organization's policy and procedure for seeking
          external assurance, including details on the involvement of the
          highest governance body and senior executives.
        </p>
        <Box sx={{ ml: 2 }}>
          <InputField
            placeholder={"Enter Text"}
            value={formData?.policyAndProcedure}
            handleChange={handleChange}
            disabled={disabled}
            mt="-5px"
            fieldName="policyAndProcedure"
            errors={errors["policyAndProcedure"] && true}
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              marginTop: "5px",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["policyAndProcedure"]}
          </p>
        </Box>
      </Box>
      {/* b */}
      <p
        className={styles.ques_heading}
        style={{ textIndent: "-1rem",  }}
      >
        b. If the organization's sustainability reporting has undergone external
        assurance:
      </p>
      <Box sx={{ mt: hide ? "-2.3rem" : "1rem", ml: 2.5 }}>
        {questionData.map((el) => (
          <Box>
            <p
              className={styles.ques_heading}
              style={{
                textIndent: el?.letter === "iii." ? "-1.3rem" : "-1rem",
                // marginLeft: "1rem",
              }}
            >
              {el.title}
            </p>
            <Box sx={{ ml: 2 }}>
              <InputField
                placeholder={"Enter Text"}
                fieldName={el.fieldName}
                disabled={disabled}
                mt="-5px"
                value={formData?.underGoneAssurance?.[el.fieldName]}
                handleChange={handleChange}
                errors={errors[el.fieldName] && true}
              />
              <p
                color="error"
                variant="caption"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  marginTop: "5px",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                }}
              >
                {errors[el.fieldName]}
              </p>
            </Box>
          </Box>
        ))}
      </Box>
      {/* 2 */}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GeneralDisclosure25;
